webpackJsonp([2,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(74);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(68);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ },

/***/ 28:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var rand = function rand(min, max) {
	  return Math.floor(Math.random() * (max - min + 1) + min);
	};
	
	exports.default = function (size, min, max) {
	  var data = [];
	  for (var i = 0; i < size; i++) {
	    var num = rand(min, max);
	    data.push(num);
	  }
	  return data;
	};

/***/ },

/***/ 29:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Demo = __webpack_require__(70);
	
	var _Demo2 = _interopRequireDefault(_Demo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Demo: _Demo2.default
	  }
	};

/***/ },

/***/ 30:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(33);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(15);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _d = __webpack_require__(62);
	
	var d3 = _interopRequireWildcard(_d);
	
	var _tween = __webpack_require__(67);
	
	var _tween2 = _interopRequireDefault(_tween);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var props = {
	  data: {
	    type: Array,
	    default: function _default() {
	      return [];
	    }
	  },
	  width: {
	    type: Number,
	    default: 0
	  },
	  height: {
	    type: Number,
	    default: 0
	  },
	  margin: {
	    type: Object,
	    default: function _default() {
	      return {
	        left: 0,
	        right: 0,
	        top: 10,
	        bottom: 10
	      };
	    }
	  },
	  max: {
	    type: Number,
	    default: 100
	  }
	};
	
	exports.default = {
	  name: 'area-chart',
	  props: props,
	  data: function data() {
	    return {
	      paths: {
	        area: '',
	        line: '',
	        selector: ''
	      },
	      lastHoverPoint: {},
	      scaled: {
	        x: null,
	        y: null
	      },
	      animatedData: [],
	      points: []
	    };
	  },
	
	  computed: {
	    actualDims: function actualDims() {
	      var width = this.width - this.margin.left - this.margin.right;
	      var height = this.height - this.margin.top - this.margin.bottom;
	      return { width: width, height: height };
	    }
	  },
	  watch: {
	    data: function dataChanged(newData, oldData) {
	      var vm = this;
	      function animate(time) {
	        requestAnimationFrame(animate);
	        _tween2.default.update(time);
	      }
	      new _tween2.default.Tween(oldData).easing(_tween2.default.Easing.Quadratic.Out).to(newData, 500).onUpdate(function onUpdate() {
	        vm.animatedData = this;
	        vm.render();
	      }).start();
	      animate();
	    },
	    width: function widthChanged() {
	      this.initialize();
	      this.render();
	    }
	  },
	  methods: {
	    createArea: d3.area().x(function (d) {
	      return d.x;
	    }).y0(function (d) {
	      return d.max;
	    }).y1(function (d) {
	      return d.y;
	    }),
	    createLine: d3.line().x(function (d) {
	      return d.x;
	    }).y(function (d) {
	      return d.y;
	    }),
	    createValueSelector: d3.area().x(function (d) {
	      return d.x;
	    }).y0(function (d) {
	      return d.max;
	    }).y1(0),
	    initialize: function initialize() {
	      this.scaled.x = d3.scaleLinear().range([0, this.actualDims.width]);
	      this.scaled.y = d3.scaleLinear().range([this.actualDims.height, 0]);
	      d3.axisLeft().scale(this.scaled.x);
	      d3.axisBottom().scale(this.scaled.y);
	    },
	    render: function render() {
	      this.scaled.x.domain(d3.extent(this.data, function (d, i) {
	        return i;
	      }));
	      this.scaled.y.domain([0, this.max]);
	      this.points = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.animatedData.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
	              i = _step$value[0],
	              d = _step$value[1];
	
	          this.points.push({
	            x: this.scaled.x(i),
	            y: this.scaled.y(d),
	            max: this.height
	          });
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      this.paths.area = this.createArea(this.points);
	      this.paths.line = this.createLine(this.points);
	    },
	    mouseover: function mouseover(_ref) {
	      var offsetX = _ref.offsetX;
	
	      if (this.points.length > 0) {
	        var x = offsetX - this.margin.left;
	        var closestPoint = this.getClosestPoint(x);
	        if (this.lastHoverPoint.index !== closestPoint.index) {
	          var point = this.points[closestPoint.index];
	          this.paths.selector = this.createValueSelector([point]);
	          this.$emit('select', this.data[closestPoint.index]);
	          this.lastHoverPoint = closestPoint;
	        }
	      }
	    },
	    getClosestPoint: function getClosestPoint(x) {
	      return this.points.map(function (point, index) {
	        return { x: point.x,
	          diff: Math.abs(point.x - x),
	          index: index
	        };
	      }).reduce(function (memo, val) {
	        return memo.diff < val.diff ? memo : val;
	      });
	    }
	  }
	};

/***/ },

/***/ 31:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AreaChart = __webpack_require__(69);
	
	var _AreaChart2 = _interopRequireDefault(_AreaChart);
	
	var _randomData = __webpack_require__(28);
	
	var _randomData2 = _interopRequireDefault(_randomData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'demo',
	  data: function data() {
	    return {
	      data: [],
	      chartWidth: 0,
	      currentValue: null,
	      itemCount: 25,
	      min: 10,
	      max: 100
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    window.addEventListener('resize', this.onResize);
	    this.onResize();
	    setInterval(function () {
	      _this.data = (0, _randomData2.default)(_this.itemCount, parseInt(_this.min, 10), parseInt(_this.max, 10));
	    }, 2000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    window.removeEventListener('resize', this.onResize);
	  },
	
	  methods: {
	    onResize: function onResize() {
	      var chartContainer = this.$el.querySelector('.area-chart');
	      this.chartWidth = chartContainer.offsetWidth;
	    },
	    onSelect: function onSelect(value) {
	      this.currentValue = value;
	    }
	  },
	  components: {
	    AreaChart: _AreaChart2.default
	  }
	};

/***/ },

/***/ 63:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 64:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 65:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 68:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(65)
	
	/* script */
	__vue_exports__ = __webpack_require__(29)
	
	/* template */
	var __vue_template__ = __webpack_require__(73)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 69:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(64)
	
	/* script */
	__vue_exports__ = __webpack_require__(30)
	
	/* template */
	var __vue_template__ = __webpack_require__(72)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 70:
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(63)
	
	/* script */
	__vue_exports__ = __webpack_require__(31)
	
	/* template */
	var __vue_template__ = __webpack_require__(71)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },

/***/ 71:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', [_c('div', {
	    staticClass: "area-chart"
	  }, [_c('h1', [_vm._v("Example Area Chart")]), _vm._v(" "), _c('area-chart', {
	    attrs: {
	      "data": _vm.data,
	      "width": _vm.chartWidth,
	      "height": 300,
	      "max": _vm.max
	    },
	    on: {
	      "select": _vm.onSelect
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('h3', [_vm._v("Selected Value: " + _vm._s(_vm.currentValue))]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Record Count: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model:value",
	      value: (_vm.itemCount),
	      expression: "itemCount",
	      arg: "value"
	    }],
	    domProps: {
	      "value": _vm._s(_vm.itemCount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.itemCount = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Min Value: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model:value",
	      value: (_vm.min),
	      expression: "min",
	      arg: "value"
	    }],
	    domProps: {
	      "value": _vm._s(_vm.min)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.min = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Max Value: ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model:value",
	      value: (_vm.max),
	      expression: "max",
	      arg: "value"
	    }],
	    domProps: {
	      "value": _vm._s(_vm.max)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.max = $event.target.value
	      }
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ },

/***/ 72:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('svg', {
	    attrs: {
	      "width": _vm.width,
	      "height": _vm.height
	    },
	    on: {
	      "mousemove": _vm.mouseover
	    }
	  }, [_c('g', {
	    style: ({
	      transform: ("translate(" + (_vm.margin.left) + "px, " + (_vm.margin.top) + "px)")
	    })
	  }, [_c('path', {
	    staticClass: "area",
	    attrs: {
	      "d": _vm.paths.area
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "line",
	    attrs: {
	      "d": _vm.paths.line
	    }
	  }), _vm._v(" "), _c('path', {
	    staticClass: "selector",
	    attrs: {
	      "d": _vm.paths.selector
	    }
	  })])])
	},staticRenderFns: []}

/***/ },

/***/ 73:
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('demo')])
	},staticRenderFns: []}

/***/ }

});


// WEBPACK FOOTER //
// samples/vuejs-d3/static/js/app.24b123020c2e911414bb.js